import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Home from "./components/Home";
import AnalyticsDashboard from "./components/AnalyticsDashboard";
import Login from "./components/Login";
import PrivateRoute from "./components/PrivateRoute";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsConditions from "./components/TermsConditions";
import CookiePolicy from "./components/CookiePolicy";
import GDPRCompliance from "./components/GDPRCompliance";
import Support from "./components/Support";
import DataDeletion from "./components/DataDeletion";

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <AnalyticsDashboard />
                </PrivateRoute>
              }
            />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/gdpr-compliance" element={<GDPRCompliance />} />
            <Route path="/support" element={<Support />} />
            <Route path="/data-deletion" element={<DataDeletion />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
